__turbopack_context__.v({
  "articleTitle": "styles-module__eZRjxq__articleTitle",
  "card": "styles-module__eZRjxq__card",
  "content": "styles-module__eZRjxq__content",
  "date": "styles-module__eZRjxq__date",
  "first": "styles-module__eZRjxq__first",
  "image": "styles-module__eZRjxq__image",
  "imageWrapper": "styles-module__eZRjxq__imageWrapper",
  "tag": "styles-module__eZRjxq__tag",
  "tags": "styles-module__eZRjxq__tags",
});
